<template>
	<div class="crud-wrapper">
		<crud :form-component="pendingAffiliatesForm" :grid-columns="gridColumns" :grid-options="gridOptions" :gridSettings="{noNew: true}" obj="pendingAffiliate" ref="crud">
		</crud>
	</div>
</template>
<script>
import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
import pendingAffiliatesForm from './PendingAffiliatesForm';
import gql from 'graphql-tag';

const GET_PENDING_AFFILIATE_SUBS = gql`
    subscription subsGetPendingAffiliates {
        affiliate(where: {user_status_id: {_in: [3,4]}}) {
            id
            userStatusId: user_status_id
        }
    }
`;

export default PageClass.extend({
	name: 'PendingAffiliate',
	data() {
		return {
			pendingAffiliatesForm,

			crudGrid: null,

			gridOptions: {},

			gridColumns: [
				{
					dataField: 'federalId',
					caption: 'CPF/CNPJ',
					cellTemplate: function (data, info) {
						let federalId = info.data.federalId.replace(/[^\d]/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
						$(`<span>${info.data.afcFederalId ? info.data.afcFederalId : federalId}</span>`).appendTo(data);
					},
					minWidth: 150
				},
				{
					dataField: 'name',
					caption: 'Nome',
					minWidth: 150
				},
				{
					dataField: 'city',
					caption: 'Cidade',
					minWidth: 150
				},
				{
					dataField: 'state',
					caption: 'Estado',
					width: 100
				},
				{
					dataField: 'afcId',
					caption: 'Tipo',
					customizeText: function (data) {
						return data.value ? 'Jurídica' : 'Física';
					},
					width: 100
				},
				{
					dataField: 'userStatusName',
					caption: 'Status',
					alignment: 'center',
					minWidth: 150
				}
			],
		}
	},

	mounted() {
		this.crudGrid = this.$refs.crud.$refs.crudGrid;
	},

	created() {
		this.$apollo.subscribe({
			query: GET_PENDING_AFFILIATE_SUBS
		}).subscribe((data) => {
			if (this.crudGrid) {
				this.crudGrid.refresh();
			}
		});
	}
})
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/PendingAffiliates.vue